import {
  IonIcon, IonLabel,
} from '@ionic/react';
import { closeOutline } from 'ionicons/icons';

import { Product } from '@/redux/orderManaged/orderManagedInterface';

import styles from './ModalOrderDetail.module.scss';

interface ModalOrderDetailProps {
  onDismiss: () => void;
  products: Product[];
}

export default function ModalOrderDetail({ onDismiss, products }: ModalOrderDetailProps) {
  return (
    <div
      id="pepper-order-detail-modal"
      className={styles.modalContainerOrderDetail}
    >
      <div className={styles.miniModal}>
        <div className={styles.miniModalHeader}>
          <IonLabel className={styles.miniModalTitle}>Detalles del pedido</IonLabel>
          <IonIcon
            icon={closeOutline}
            className={styles.miniModalCloseIcon}
            onClick={onDismiss}
          />
        </div>
        <div className={styles.miniModalContent}>
          <div className={styles.miniModalItems}>
            {products.length > 0 ? (
              products.map((item, index) => (
                <div key={index} className={styles.miniModalItem}>
                  <IonLabel className={styles.itemName}>
                    {' '}
                    {item.name}
                  </IonLabel>
                  <div className={styles.itemQuantityWrapper}>
                    <IonLabel className={styles.itemLabel}>Cantidad:</IonLabel>
                    <IonLabel className={styles.itemValue}>{item.qty}</IonLabel>
                  </div>
                  <div className={styles.itemQuantityWrapper}>
                    <IonLabel className={styles.itemLabel}>Precio unitario:</IonLabel>
                    <IonLabel className={styles.itemValue}>
                      {item.price}
                      €
                    </IonLabel>
                  </div>
                </div>
              ))) : (
              <div className={styles.itemQuantityWrapper}>
                <IonLabel className={styles.noItems}>No se han podido obtener los productos.</IonLabel>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
